import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const BASE = "https://tuttimieilink.com";

const LandingSchema = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const faqItems = t("faq.items", { returnObjects: true }) as { q: string; a: string }[];

    const schemas = [
      // Organization
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "TuttiIMieiLink",
        url: BASE,
        logo: `${BASE}/logo.jpg`,
        sameAs: [
          "https://www.instagram.com/tuttimieilink",
        ],
        description: t("hero.subtitle"),
      },
      // WebSite with SearchAction
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "TuttiIMieiLink",
        url: BASE,
        inLanguage: i18n.language,
        potentialAction: {
          "@type": "SearchAction",
          target: `${BASE}/?q={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      },
      // SoftwareApplication
      {
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        name: "TuttiIMieiLink",
        applicationCategory: "BusinessApplication",
        operatingSystem: "Web",
        url: BASE,
        offers: [
          {
            "@type": "Offer",
            price: "0",
            priceCurrency: "EUR",
            name: "Free",
          },
          {
            "@type": "Offer",
            price: "7",
            priceCurrency: "EUR",
            name: "Creator",
            priceSpecification: {
              "@type": "UnitPriceSpecification",
              price: "7",
              priceCurrency: "EUR",
              unitText: "MONTH",
              referenceQuantity: {
                "@type": "QuantitativeValue",
                value: "1",
                unitCode: "MON",
              },
            },
          },
          {
            "@type": "Offer",
            price: "23",
            priceCurrency: "EUR",
            name: "Business",
            priceSpecification: {
              "@type": "UnitPriceSpecification",
              price: "23",
              priceCurrency: "EUR",
              unitText: "MONTH",
            },
          },
        ],
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "4.9",
          reviewCount: "200",
          bestRating: "5",
        },
      },
      // FAQPage
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqItems.map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: {
            "@type": "Answer",
            text: item.a,
          },
        })),
      },
    ];

    const id = "landing-schema";
    let script = document.getElementById(id) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement("script");
      script.id = id;
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schemas);

    return () => {
      script?.remove();
    };
  }, [t, i18n.language]);

  return null;
};

export default LandingSchema;
